import { useEffect } from 'react';
import HeaderHero from './HeaderHero';
import Partners from './Partners';
import About from './About';
//import ProxEvents from './ProxEvents';
import PastEvents from './PastEvents';
import ContactUs from './ContactUs';
import Footer from './Footer';
import HowWeDoIt from './HowWeDoIt';

const WATCHED = [
  '.hero-title', '.hero-subtitle', '.hero-cta',
  '.about-title', '.how-title', '.partners-title',
  '.past-title', '.events-title', '.contact-heading',
  '.partner', '.partners-swiper',
].join(', ');

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll(WATCHED).forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div >
      <HeaderHero />
      <Partners />
      <About />
      {/* <ProxEvents /> */}
      <PastEvents />
      <HowWeDoIt />
      <ContactUs />
      <Footer />
    </div>
  );
}

export default App;
